// window.ElectronApi = {
//     Comm : {
//         init: () => '',
//         isElectron : () => false,
//         isElectronAvailable: () => false,
//     }
// };

var NormalLogin = (function () {

    return {
        clickNormalLoginButton: clickNormalLoginButton,
    }

    function clickNormalLoginButton() {

        var userId = $.trim($("#userId").val());
        var password = $.trim($("#password").val());
        var isElectron = ElectronApi.Comm.isElectron();
        const ID_GB = ServerChecker.isSeco ? SignCode.TYPE.SECO : SignCode.TYPE.NORMAL;
        const CMPN_CD = $.trim($("#companyCode").val());

        let authType = ServerChecker.isKsfc ? $.trim($("#otpType").val()) : '';

        CommonLogin.goLogin({
            USER_ID: userId,
            PWD: password,
            ID_GB,
            ENCRYPT_YN: SignCode.ENCRYPT.SERVER_TIME_CHECK,
            OBJ_CNTS_NM: (isElectron ? "desktop" : ""),
            SUB_DOM,
            CMPN_CD,
            OTP_TYPE: authType,
        })
    }

})()